import React, { useEffect, useState } from "react";
import signupimage from "../../images/signup-g.svg";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import api from "../../utils/api";

const MyAccountSignUp = () => {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* ======================
     ALREADY LOGGED IN
  ====================== */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) navigate("/", { replace: true });
  }, [navigate]);

  /* ======================
     REGISTER USER
  ====================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!/^[0-9]{10}$/.test(phone)) {
      setError("Enter a valid 10-digit phone number");
      return;
    }

    const form = new FormData(e.target);

    const userData = {
      name: `${form.get("firstName")} ${form.get("lastName")}`,
      email,
      phone,
      password: form.get("password"),
    };

    try {
      setLoading(true);

const res = await api.post("/api/auth/register", userData);

/* SAME AS SIGN IN */
localStorage.setItem("token", res.data.token);

localStorage.setItem(
  "user",
  JSON.stringify(res.data.user)
);

localStorage.setItem(
  "userId",
  res.data.user._id
);

alert("🎉 Registration successful!");

navigate("/", { replace: true });

      
    } catch (err) {
      setError(err.response?.data?.message || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ScrollToTop />

      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row justify-content-center align-items-center g-5">

            <div className="col-12 col-md-6 col-lg-4 text-center order-lg-1 order-2">
              <img
                src={signupimage}
                alt="signup"
                className="img-fluid"
                style={{ maxWidth: "380px" }}
              />
            </div>

            <div className="col-12 col-md-6 col-lg-5 order-lg-2 order-1">
              <h1 className="mb-3 h2 fw-bold">Create Account</h1>

              {error && <div className="alert alert-danger">{error}</div>}

              <form onSubmit={handleSubmit}>
                <div className="row g-3">

                  <div className="col-md-6">
                    <input
                      name="firstName"
                      className="form-control"
                      placeholder="First name"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      name="lastName"
                      className="form-control"
                      placeholder="Last name"
                      required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Phone number"
                      value={phone}
                      maxLength={10}
                      onChange={(e) =>
                        setPhone(e.target.value.replace(/\D/g, ""))
                      }
                      required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      placeholder="Create Password"
                      required
                    />
                  </div>

                  <div className="col-12 d-grid">
                    <button
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Registering..." : "Register"}
                    </button>

                    <span className="text-center mt-2">
                      Already have an account?{" "}
                      <Link to="/MyAccountSignIn">Sign in</Link>
                    </span>
                  </div>

                </div>
              </form>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountSignUp;